<template>
  <Skeleton title :row="8" :loading="loading">
    <div>
      <div class="con">
        <CheckboxGroup v-model="select">
          <div class="list" v-for="item in list" v-bind:key="item.uniqueId" @click="toggleSelect(item.uniqueId)">
            <div class="title">
              <span>
                <Checkbox checked-color="#00CCBF" :name="item.uniqueId">
                  {{ item.visitorName }}
                </Checkbox>
              </span>
              <span class="time">{{ item.created | timeFormat }}</span>
            </div>

            <div class="content">
              <img :src="getUrl(item)" alt class="cover" />
              <div class="info">
                <p>
                  {{ $t('user.review.phone') }}:
                  <span>{{ item.telephone }}</span>
                </p>
                <p>
                  {{ $t('user.review.time') }}:
                  <span>{{ item | allTime }}</span>
                </p>
                <p>
                  {{ $t('user.review.reason') }}:
                  <span>{{ item.reason }}</span>
                </p>
              </div>
            </div>

            <div class="addon" v-if="item.visitorPeers && item.visitorPeers.length > 0">
              <VisitorAddonDetail :value="item.visitorPeers" :type="item.passType === 1"></VisitorAddonDetail>
            </div>
          </div>
        </CheckboxGroup>
      </div>
      <div class="footer" :style="{ bottom: '50px' }" v-if="select.length > 0">
        <span class="reject" @click="reject">
          {{ $t('user.review.reject') }}
        </span>
        <span class="proceed" @click="proceed">
          {{ $t('user.review.proceed') }}
        </span>
      </div>
    </div>
  </Skeleton>
</template>

<script>
import qrcode from '@/assets/icon/qrcode.svg';
import moment from 'moment';
import { Skeleton, Checkbox, CheckboxGroup } from 'vant';
import api from '@/services/api';
import VisitorAddonDetail from '@/components/visitorAddonDetail.vue';
import { replaceUrl } from '@/utils/url-ip-replace';
export default {
  components: { Skeleton, Checkbox, CheckboxGroup, VisitorAddonDetail },
  data() {
    return {
      loading: true,
      list: [],
      select: [],
      qrcode,
    };
  },
  methods: {
    getUrl(item) {
      return item.passType === 1 ? replaceUrl(item.photoData) : qrcode;
    },
    initData() {
      this.loading = true;
      api
        .visitorList({
          listType: 1,
        })
        .then(res => {
          const [success, result] = res;
          if (success) {
            this.list = [...result.data];
          }
          this.loading = false;
        });
    },
    toggleSelect(id) {
      if (this.select.includes(id)) {
        const list = this.select.filter(item => item !== id);
        this.select = [...list];
      } else {
        this.select.push(id);
      }
    },
    reject() {
      this.$router.push({
        name: 'visitorOptionReject',
        params: { select: this.select },
      });
    },
    proceed() {
      // this.$router.push({
      //   name: 'visitorOptionProceed',
      //   params: { select: this.select },
      // });
      api
        .review({
          uniqueIds: this.select.join(','),
          remark: null,
          verifyStatus: 1,
        })
        .then(res => {
          const [success] = res;
          if (success) {
            this.$router.push({ name: 'visitorOptionResult' });
          }
        });
    },
  },
  computed: {
    historySelect() {
      return window.history.state && window.history.state.select;
    },
  },
  filters: {
    timeFormat(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
    allTime(item) {
      if (item && item.startTime && item.endTime) {
        return moment(item.startTime).format('YYYY-MM-DD HH:mm~') + moment(item.endTime).format('HH:mm');
      }
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="less" scoped>
.con {
  padding: 16px 30px;

  .list {
    background-color: white;
    border-radius: 4px;
    margin-bottom: 16px;
    padding: 25px 30px 30px 30px;
    box-sizing: border-box;
    user-select: none;

    .title {
      height: 55px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.03);
      display: flex;
      justify-content: space-between;

      span {
        font-size: 32px;
        color: #3d424d;
        letter-spacing: 0;
        text-align: right;
        line-height: 38px;
      }

      .time {
        font-size: 24px;
        color: #7e838c;
      }
    }

    .content {
      padding-top: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .cover {
        width: 120px;
        height: 120px;
        border-radius: 4px;
        margin-right: 30px;
        object-fit: contain;
      }

      .info {
        flex: 1;
        font-size: 28px;
        color: #5d6067;
        letter-spacing: 0;
        line-height: 42px;
        text-align: left;

        span {
          margin-left: 8px;
        }
      }
    }

    .addon {
      border-top: 1px solid rgba(0, 0, 0, 0.08);
      margin-top: 17px;
      margin-bottom: -28px;
    }
  }
}

.footer {
  width: 100%;
  height: 94px;
  position: fixed;
  display: flex;
  font-size: 36px;
  color: #ffffff;
  text-align: center;
  line-height: 36px;
  line-height: 94px;

  .reject {
    width: 50%;
    background: #3d424d;
  }

  .proceed {
    width: 50%;
    background: #00ccbf;
  }
}
</style>
